"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "LaunchpadLogo___StyledSvg",
  componentId: "sc-3u2b09-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function LaunchpadLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M440.566 39.205c-6.61-6.589-16.625-9.669-31.516-9.669-29.823 0-88.305 14.075-127.144 52.934l-80.574 80.554H65.56A20.514 20.514 0 0051.118 169l-14.422 14.442c-7.955 7.975-7.955 20.888 0 28.864l230.788 230.768a20.343 20.343 0 0014.422 5.976c5.222 0 10.444-1.999 14.422-5.976l14.442-14.422c3.835-3.835 5.956-9.016 5.956-14.442V278.418l80.574-80.574c29.333-29.313 42.266-67.172 47.345-87.081 4.12-16.176 11.974-55.504-4.08-71.558zm-280.01 164.616l-37.31 37.309-37.328-37.31h74.638zm-8.466 66.172l144.238-144.237 57.687 57.666L209.798 327.68l-57.708-57.687zm123.86 123.84l-37.309-37.289 37.309-37.33v74.619zM381.43 153.15L326.6 98.32c28.557-20.052 63.908-27.987 82.45-27.987h.571c.245 16.441-7.405 53.2-28.19 82.818zM152.07 385.388c5.303-5.304 8.649-11.689 10.423-18.481l30.802 30.822c-3.427 5.854-7.343 11.464-12.361 16.482-27.987 27.986-112.11 33.902-128.694 34.8l-22.704 1.223 1.224-22.683c.898-16.584 6.772-100.707 34.78-128.735 4.997-4.997 10.627-8.934 16.461-12.361l30.802 30.802c-6.732 1.795-13.157 5.14-18.42 10.423-8.955 8.935-17.033 44.081-20.929 78.616 34.412-3.814 69.437-11.75 78.616-20.908z"
  }));
}

var _default = LaunchpadLogo;
exports["default"] = _default;